import {
  Calendar, CreditCard, Download, MessageCircle, Repeat, Search, TriangleAlert,
} from 'lucide-react';

/**
 * The icon set the plan tab draws from.
 *
 * The prototype's raw SVG paths are lucide's, so this maps them back to the
 * library rather than inlining path data that would drift from it.
 */
export const PlanIcon = {
  interaction: MessageCircle,
  partnershipSearch: Search,
  card: CreditCard,
  calendar: Calendar,
  cycle: Repeat,
  alert: TriangleAlert,
  download: Download,
} as const;

export type PlanIconName = keyof typeof PlanIcon;
